"use strict";
var _a, _b;
exports.__esModule = true;
exports.getMultiAgent = exports.deleteMultiAgent = exports.updateMultiAgent = exports.createMultiAgentBot = exports.downloadOrDeleteFile = exports.uploadFileToVertex = exports.getFileData = exports.createCodeExecutorFunction = exports.createCodeNodeAction = exports.syncCatalog = exports.getSyncCatalogStatus = exports.fetchEnvVariables = exports.createNewAction = exports.updateAgent = exports.deleteAction = exports.updateAction = exports.getActionData = exports.getVoiceModels = exports.getModels = exports.getActions = exports.getAgents = void 0;
var utils_1 = require("@src/api/utils");
var const_1 = require("@src/const");
var multiAgentDevBaseUrl = const_1.BASE_URL.replace('/mogambo_api', '') + "call_genie_voice/";
var environment = (_a = process.env.ENV_NAME) === null || _a === void 0 ? void 0 : _a.toLowerCase();
var isStaging = ['stag', 'staging'].includes(environment);
var isProduction = ['prod', 'production'].includes(environment);
var platform = (_b = process.env.PLATFORM) === null || _b === void 0 ? void 0 : _b.toLowerCase();
if (!platform && typeof window !== 'undefined') {
    if (window.location.hostname.includes('jio')) {
        platform = 'jio';
    }
    else if (window.location.hostname.includes('haptik')) {
        platform = 'haptik';
    }
}
var callGenieBaseUrl = process.env.CALL_GENIE_BASE_URL;
var multiAgentBaseUrl = callGenieBaseUrl ||
    (function () {
        if (platform === 'jio') {
            if (isStaging) {
                return 'https://jio-api-appgw.hellohaptik.com/call-genie-voice/';
            }
            if (isProduction) {
                return 'https://jio-api.haptikapi.com/call-genie-voice/';
            }
        }
        else if (platform === 'haptik') {
            // Default to Haptik
            if (isStaging) {
                return 'https://staging.hellohaptik.com/call-genie-voice/';
            }
            if (isProduction) {
                return 'https://api.haptikapi.com/call-genie-voice/';
            }
        }
        // Local/other environments
        return multiAgentDevBaseUrl;
    })();
exports.getAgents = function (domainId, toolType) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/";
    if (Number.isInteger(toolType)) {
        url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/?tool_id=" + toolType;
    }
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getActions = function (agentId) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/actions/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getModels = function (domainId) {
    var url = const_1.BASE_URL + "ai_agents/models/?domain_id=" + domainId + "&tool=classic";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getVoiceModels = function () {
    var url = const_1.BASE_URL + "ai_agents/models/?tool=voice";
    return utils_1.mogamboRequestV3(url, 'GET', undefined, undefined, undefined, true);
};
exports.getActionData = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.updateAction = function (agentId, action_id, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data);
};
exports.deleteAction = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/?delete=true";
    return utils_1.mogamboRequestV3(url, 'POST');
};
exports.updateAgent = function (domainId, ai_agent, data) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agent/" + ai_agent + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data, null, {});
};
exports.createNewAction = function (agentId, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.fetchEnvVariables = function (domainId) {
    var url = const_1.BASE_URL + "domain/env_variables/" + domainId + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getSyncCatalogStatus = function (actionId) {
    var url = const_1.BASE_URL + "meta_catalog/" + actionId + "/sync/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.syncCatalog = function (actionId, data) {
    var url = const_1.BASE_URL + "meta_catalog/" + actionId + "/sync/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.createCodeNodeAction = function (agentId, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/code-node-action/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.createCodeExecutorFunction = function (data) {
    var url = const_1.BASE_URL + "code_executor/create/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null, undefined, true);
};
exports.getFileData = function (domainId, appId) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?app_id=" + appId + "&use_case=gcp_vertex_rag";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.uploadFileToVertex = function (domainId, appId, actionType, data) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?action_type=" + actionType + "&app_id=" + appId + "&use_case=gcp_vertex_rag";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.downloadOrDeleteFile = function (domainId, appId, actionType, data, fileName) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?action_type=" + actionType + "&app_id=" + encodeURIComponent(appId) + "&use_case=gcp_vertex_rag&file_name=" + encodeURIComponent(fileName);
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
// Call Genie Voice Multi Agent APIs
exports.createMultiAgentBot = function (pipecatVoiceId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents";
    return utils_1.mogamboRequestV3(url, 'POST', payload, null, undefined, true);
};
exports.updateMultiAgent = function (pipecatVoiceId, agentId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents/" + agentId;
    return utils_1.mogamboRequestV3(url, 'PATCH', payload, null, undefined, true);
};
exports.deleteMultiAgent = function (pipecatVoiceId, agentId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents/" + agentId + "/delete";
    return utils_1.mogamboRequestV3(url, 'POST', payload, null, undefined, true);
};
exports.getMultiAgent = function (pipecatVoiceId) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents";
    return utils_1.mogamboRequestV3(url, 'GET', undefined, undefined, undefined, true);
};
